/* THE CROSSING . Capital Bridge USA . theme.js
   Vanilla only. No dependencies. */
(function () {
  'use strict';

  var doc = document;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
    doc.documentElement.classList.contains('cb-no-motion');

  /* ---------- Word-split headlines ---------- */
  function splitWords() {
    doc.querySelectorAll('[data-cb-split]').forEach(function (el) {
      if (el.dataset.cbSplitDone) return;
      el.dataset.cbSplitDone = '1';
      var nodes = Array.prototype.slice.call(el.childNodes);
      el.textContent = '';
      var idx = 0;
      nodes.forEach(function (node) {
        if (node.nodeType === 3) {
          node.textContent.split(/\s+/).forEach(function (word) {
            if (!word) return;
            var w = doc.createElement('span');
            w.className = 'cb-w';
            var wi = doc.createElement('span');
            wi.className = 'cb-wi';
            wi.textContent = word;
            wi.style.transitionDelay = (0.06 * idx) + 's';
            w.appendChild(wi);
            el.appendChild(w);
            el.appendChild(doc.createTextNode(' '));
            idx++;
          });
        } else {
          var w2 = doc.createElement('span');
          w2.className = 'cb-w';
          var wi2 = doc.createElement('span');
          wi2.className = 'cb-wi';
          wi2.style.transitionDelay = (0.06 * idx) + 's';
          wi2.appendChild(node);
          w2.appendChild(wi2);
          el.appendChild(w2);
          el.appendChild(doc.createTextNode(' '));
          idx++;
        }
      });
    });
  }

  /* ---------- Reveal engine ---------- */
  function initReveals() {
    var targets = doc.querySelectorAll('[data-cb-reveal],[data-cb-stagger],[data-cb-watch]');
    if (!('IntersectionObserver' in window) || reduced) {
      targets.forEach(function (t) { t.classList.add('cb-inview'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var el = entry.target;
          var delay = parseFloat(el.dataset.cbDelay || 0);
          if (delay) {
            setTimeout(function () { el.classList.add('cb-inview'); }, delay * 1000);
          } else {
            el.classList.add('cb-inview');
          }
          io.unobserve(el);
        }
      });
    }, { threshold: 0.16, rootMargin: '0px 0px -6% 0px' });
    targets.forEach(function (t) { io.observe(t); });
  }

  /* ---------- Counters ---------- */
  function animateCount(el) {
    var end = parseFloat(el.dataset.cbCount);
    var decimals = parseInt(el.dataset.cbDecimals || '0', 10);
    var dur = parseFloat(el.dataset.cbDur || '1.8') * 1000;
    if (reduced) { el.textContent = end.toFixed(decimals); return; }
    var start = null;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = (end * eased).toFixed(decimals);
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  function initCounters() {
    var els = doc.querySelectorAll('[data-cb-count]');
    if (!('IntersectionObserver' in window) || reduced) {
      els.forEach(function (el) { el.textContent = parseFloat(el.dataset.cbCount).toFixed(parseInt(el.dataset.cbDecimals || '0', 10)); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { animateCount(e.target); io.unobserve(e.target); }
      });
    }, { threshold: 0.5 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- SVG stroke prep (paths animated with dasharray:1 shorthand) ---------- */
  function prepStrokes() {
    doc.querySelectorAll('[data-cb-stroke]').forEach(function (path) {
      try {
        var len = path.getTotalLength();
        path.style.strokeDasharray = len;
        path.style.strokeDashoffset = len;
      } catch (err) { /* non-path element */ }
    });
  }

  /* ---------- Gauges ---------- */
  function initGauges() {
    doc.querySelectorAll('.cb-gauge').forEach(function (g) {
      var fill = g.querySelector('.cb-g-fill');
      if (!fill) return;
      var pct = Math.max(0, Math.min(100, parseFloat(g.dataset.cbPct || '75')));
      try {
        var len = fill.getTotalLength();
        fill.style.strokeDasharray = len;
        fill.style.strokeDashoffset = len;
        var apply = function () {
          fill.style.strokeDashoffset = len * (1 - pct / 100);
        };
        if (reduced) { apply(); return; }
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { apply(); io.unobserve(e.target); }
          });
        }, { threshold: 0.4 });
        io.observe(g);
      } catch (err) { /* noop */ }
    });
  }

  /* ---------- Header ---------- */
  function initHeader() {
    var header = doc.querySelector('.cb-header');
    if (!header) return;
    var onScroll = function () {
      header.classList.toggle('cb-scrolled', window.scrollY > 12);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    var burger = header.querySelector('.cb-burger');
    if (burger) {
      burger.addEventListener('click', function () {
        var open = header.classList.toggle('cb-mobile-open');
        burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }
  }

  /* ---------- Hero bridge sequence ---------- */
  function initBridge() {
    doc.querySelectorAll('.cb-bridge').forEach(function (bridge) {
      bridge.querySelectorAll('.cb-b-cable').forEach(function (c) {
        try {
          var len = c.getTotalLength();
          c.style.strokeDasharray = len;
          c.style.strokeDashoffset = len;
        } catch (err) { /* noop */ }
      });
      var hangers = bridge.querySelectorAll('.cb-b-hanger');
      hangers.forEach(function (h, i) {
        h.style.transitionDelay = (1.7 + i * 0.07) + 's';
      });
      var lights = bridge.querySelectorAll('.cb-b-light');
      lights.forEach(function (l, i) {
        l.style.animationDelay = (2.6 + i * 0.12) + 's, ' + (3.2 + i * 0.3) + 's';
      });
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { bridge.classList.add('cb-play'); });
      });
    });
  }

  /* ---------- Hero stars ---------- */
  function initStars() {
    doc.querySelectorAll('.cb-hero-stars').forEach(function (field) {
      var count = 46;
      for (var i = 0; i < count; i++) {
        var s = doc.createElement('i');
        s.style.left = (Math.random() * 100) + '%';
        s.style.top = (Math.random() * 100) + '%';
        s.style.animationDelay = (Math.random() * 3.4) + 's';
        s.style.animationDuration = (2.4 + Math.random() * 3) + 's';
        field.appendChild(s);
      }
    });
  }

  /* ---------- Marquee: duplicate track content ---------- */
  function initMarquees() {
    doc.querySelectorAll('.cb-marquee-track').forEach(function (track) {
      if (track.dataset.cbDuped) return;
      track.dataset.cbDuped = '1';
      track.innerHTML = track.innerHTML + track.innerHTML;
    });
  }

  /* ---------- Deck plan (expanding segments) ---------- */
  function initDeck() {
    doc.querySelectorAll('.cb-deck-row').forEach(function (row) {
      var segs = row.querySelectorAll('.cb-deck-seg');
      function open(seg) {
        segs.forEach(function (s) { s.classList.toggle('cb-open', s === seg); });
      }
      segs.forEach(function (seg) {
        seg.addEventListener('click', function () { open(seg); });
        seg.addEventListener('mouseenter', function () {
          if (window.matchMedia('(hover:hover)').matches) open(seg);
        });
        seg.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(seg); }
        });
      });
      if (segs.length) open(segs[0]);
    });
  }

  /* ---------- Estimator ---------- */
  function fmtMoney(n) {
    return '$' + Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function initEstimator() {
    doc.querySelectorAll('[data-cb-estimator]').forEach(function (panel) {
      var amt = panel.querySelector('[data-cb-amt]');
      var term = panel.querySelector('[data-cb-term]');
      var amtOut = panel.querySelector('[data-cb-amt-out]');
      var termOut = panel.querySelector('[data-cb-term-out]');
      var lowOut = panel.querySelector('[data-cb-low]');
      var highOut = panel.querySelector('[data-cb-high]');
      if (!amt || !term) return;
      function paintRange(input) {
        var min = parseFloat(input.min), max = parseFloat(input.max), val = parseFloat(input.value);
        input.style.setProperty('--cb-fill', (((val - min) / (max - min)) * 100) + '%');
      }
      function update() {
        var a = parseFloat(amt.value);
        var t = parseFloat(term.value);
        paintRange(amt); paintRange(term);
        if (amtOut) amtOut.textContent = fmtMoney(a);
        if (termOut) termOut.textContent = t + (t === 1 ? ' month' : ' months');
        /* Illustrative factor range only, never a quote */
        var low = (a * 1.08) / t;
        var high = (a * 1.28) / t;
        if (lowOut) { lowOut.textContent = fmtMoney(low); flash(lowOut); }
        if (highOut) { highOut.textContent = fmtMoney(high); flash(highOut); }
      }
      function flash(el) {
        var box = el.closest('.cb-est-readout-num') || el;
        box.classList.remove('cb-flash');
        void box.offsetWidth;
        box.classList.add('cb-flash');
      }
      amt.addEventListener('input', update);
      term.addEventListener('input', update);
      update();
    });
  }

  /* ---------- FAQ ---------- */
  function initFaq() {
    doc.querySelectorAll('.cb-faq-item').forEach(function (item) {
      var q = item.querySelector('.cb-faq-q');
      var a = item.querySelector('.cb-faq-a');
      if (!q || !a) return;
      q.addEventListener('click', function () {
        var isOpen = item.classList.contains('cb-open');
        var list = item.parentElement;
        if (list) {
          list.querySelectorAll('.cb-faq-item.cb-open').forEach(function (other) {
            other.classList.remove('cb-open');
            var oa = other.querySelector('.cb-faq-a');
            if (oa) oa.style.maxHeight = '0px';
            var ob = other.querySelector('.cb-faq-q');
            if (ob) ob.setAttribute('aria-expanded', 'false');
          });
        }
        if (!isOpen) {
          item.classList.add('cb-open');
          a.style.maxHeight = a.scrollHeight + 'px';
          q.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  /* ---------- Testimonial columns: duplicate for seamless loop ---------- */
  function initVoices() {
    doc.querySelectorAll('.cb-voice-col').forEach(function (col) {
      if (col.dataset.cbDuped) return;
      col.dataset.cbDuped = '1';
      col.innerHTML = col.innerHTML + col.innerHTML;
    });
  }

  /* ---------- Tilt cards ---------- */
  function initTilt() {
    if (reduced || !window.matchMedia('(hover:hover)').matches) return;
    doc.querySelectorAll('[data-cb-tilt]').forEach(function (card) {
      var raf = null;
      card.addEventListener('mousemove', function (e) {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          var r = card.getBoundingClientRect();
          var x = (e.clientX - r.left) / r.width - 0.5;
          var y = (e.clientY - r.top) / r.height - 0.5;
          card.style.transform = 'perspective(900px) rotateY(' + (x * 6) + 'deg) rotateX(' + (y * -6) + 'deg) translateY(-6px)';
          raf = null;
        });
      });
      card.addEventListener('mouseleave', function () {
        card.style.transform = '';
      });
    });
  }

  /* ---------- Magnetic buttons ---------- */
  function initMagnetic() {
    if (reduced || !window.matchMedia('(hover:hover)').matches) return;
    doc.querySelectorAll('[data-cb-magnetic]').forEach(function (btn) {
      btn.addEventListener('mousemove', function (e) {
        var r = btn.getBoundingClientRect();
        var x = e.clientX - r.left - r.width / 2;
        var y = e.clientY - r.top - r.height / 2;
        btn.style.transform = 'translate(' + (x * 0.18) + 'px,' + (y * 0.28) + 'px)';
      });
      btn.addEventListener('mouseleave', function () {
        btn.style.transform = '';
      });
    });
  }

  /* ---------- Parallax ornaments ---------- */
  function initParallax() {
    if (reduced) return;
    var els = doc.querySelectorAll('[data-cb-parallax]');
    if (!els.length) return;
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var vh = window.innerHeight;
        els.forEach(function (el) {
          var speed = parseFloat(el.dataset.cbParallax || '0.12');
          var r = el.getBoundingClientRect();
          var mid = r.top + r.height / 2 - vh / 2;
          el.style.transform = 'translateY(' + (-mid * speed) + 'px)';
        });
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Reading progress ---------- */
  function initProgress() {
    var bar = doc.querySelector('.cb-progress i');
    var body = doc.querySelector('.cb-article-body');
    if (!bar || !body) return;
    function onScroll() {
      var r = body.getBoundingClientRect();
      var total = r.height - window.innerHeight;
      var done = Math.min(Math.max(-r.top, 0), Math.max(total, 1));
      bar.style.width = (total > 0 ? (done / total) * 100 : 100) + '%';
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Article TOC ---------- */
  function initToc() {
    var toc = doc.querySelector('[data-cb-toc]');
    var body = doc.querySelector('.cb-article-body');
    if (!toc || !body) return;
    var heads = body.querySelectorAll('h2');
    if (!heads.length) {
      var wrap = toc.closest('.cb-toc');
      if (wrap) wrap.style.display = 'none';
      return;
    }
    var ol = doc.createElement('ol');
    heads.forEach(function (h, i) {
      if (!h.id) h.id = 'section-' + (i + 1);
      var li = doc.createElement('li');
      var a = doc.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent;
      li.appendChild(a);
      ol.appendChild(li);
    });
    toc.appendChild(ol);
    if ('IntersectionObserver' in window) {
      var links = toc.querySelectorAll('a');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            links.forEach(function (l) {
              l.classList.toggle('cb-toc-active', l.getAttribute('href') === '#' + e.target.id);
            });
          }
        });
      }, { rootMargin: '-20% 0px -70% 0px' });
      heads.forEach(function (h) { io.observe(h); });
    }
  }

  /* ---------- Boot ---------- */
  function boot() {
    splitWords();
    prepStrokes();
    initReveals();
    initCounters();
    initGauges();
    initHeader();
    initBridge();
    initStars();
    initMarquees();
    initDeck();
    initEstimator();
    initFaq();
    initVoices();
    initTilt();
    initMagnetic();
    initParallax();
    initProgress();
    initToc();
  }

  if (doc.readyState === 'loading') {
    doc.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Shopify theme editor: re-run behaviors when sections reload */
  doc.addEventListener('shopify:section:load', function () {
    splitWords();
    prepStrokes();
    initReveals();
    initCounters();
    initGauges();
    initBridge();
    initStars();
    initMarquees();
    initDeck();
    initEstimator();
    initFaq();
    initVoices();
  });
})();
